import { useState, useEffect } from "react";
import React from "react";
import {
  machineProfile,
  part,
  workOrder,
  vendor,
  customer,
  team,
  user,
  asset,
  workOrderCategory,
  meter,
  issueTracking,
} from "../../api";
import { toast } from "react-toastify";
import {
  dateFormat,
  generateLocationToArray,
  getEmptyField,
  printLocation,
  renderImage,
} from "../../utils/helper";
import { QRCode } from "react-qrcode-logo";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LoadingIndicator from "../../components/LoadingIndicator";
import NormalInput from "../../components/form/HorizontalNormalInput";
import NormalSelect from "../../components/form/HorizontalNormalSelect";
import NormalTextArea from "../../components/form/HorizontalNormalTextarea";
import MultipleFilesAttachments from "../../components/MultipleFilesAttachments";
import "react-datetime/css/react-datetime.css";
import { Card, CardBody, CardHeader } from "../../components/card/card";

import ImageViewer from "../../components/ImageViewer";
import { format, isBefore } from "date-fns";
import { Task } from "../../components/Task";
import Swal from "sweetalert2";
import { InventorySelector } from "../../components/InventorySelector";
import TimeTracking from "../../components/TimeTracking";
import AdditionalCost from "../../components/AdditionalCost";
import { ProblemTypeFilter } from "../../components/ProblemType";
import { LocationFilter } from "../../components/LocationFilter";
import Select, { StylesConfig } from "react-select";

const colourStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "rgba(0, 0, 0, 0.48)",
    borderColor: "var(--bs-border-color)",
  }),
  input: (styles) => ({
    ...styles,
    color: "white",
  }),
  menu: (styles) => ({
    ...styles,
    color: "grey",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "white",
  }),
};

function setupLocationValues(locationSeq, location) {
  locationSeq.push(location.id);
  if (location.parent_location) {
    setupLocationValues(locationSeq, location.parent_location);
  }
}

function setupProblemTypeValues(problemTypeSeq, problemType) {
  problemTypeSeq.push(problemType.id);
  if (problemType.parent_problem_type) {
    setupProblemTypeValues(problemTypeSeq, problemType.parent_problem_type);
  }
}

const recurringType = [
  {
    name: "Daily",
    id: "daily",
  },
  {
    name: "Weekly",
    id: "weekly",
  },
  {
    name: "Every Month",
    id: "monthly",
  },
  {
    name: "Every 3 Months",
    id: "3months",
  },
  {
    name: "Every 6 Months",
    id: "6months",
  },
  {
    name: "Every year",
    id: "yearly",
  },
];

const priorityType = [
  {
    name: "Low",
    id: "low",
  },
  {
    name: "Medium",
    id: "medium",
  },
  {
    name: "High",
    id: "high",
  },
];

function AddWorkOrder({ isRequest = false }) {
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const meter_id = searchParams.get("meter_id");
  const issue_tracking_id = searchParams.get("issue_tracking_id");
  const editMode = !!id;

  const { locations, addSetupDone } = useDashboardContext();
  const [selectedLocationPrev, setSelectedLocationPrev] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedProblemTypePrev, setSelectedProblemTypePrev] = useState([]);
  const [selectedProblemType, setSelectedProblemType] = useState(null);

  const [locationValue, setLocationValue] = useState([]);
  const [vendorList, setVendor] = useState([]);
  const [customerList, setCustomer] = useState([]);
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [schedules, setSchedules] = useState([]);
  const [assets, setAssets] = useState([]);
  const [sublocations, setSublocations] = useState([]);
  const { getLocationName, username } = useAuth();
  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [assetComponents, setAssetComponents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [assignType, setAssignType] = useState("individual");
  const [dataToSend, setDataToSend] = useState({
    asset_id: "",
    start_date: "",
    number: "",
    due_date: "",
    status: "",
    is_signature_required:false,
    create_wo_for_child:"No",
    description: "",
    title: "",
    recurring_wo: "",
    recurring_end_date: "",
    is_auto_continue_recurring: false,
    priority: "medium",
    assigned_to: "",
    fault: "",
    team_id: "",
    vendor_id: "",
    category_id: "",
    request_tasks: [],
    work_order_tasks: [],
    inventories: [],
    time_entries: [],
    additional_costs: [],
    is_request: isRequest,
    meter_id: "",
    issue_tracking_id: "",
    location_id: '',
    problem_type_id: '',
    problem_type_note: ''
  });
  const navigate = useNavigate();
  function backToList() {
    navigate(-1);
  }

  const [preview, setPreview] = useState();
  const [attachments, setAttachments] = useState([]);
  const [selectedFile, setSelectedFile] = useState("");

  const [emptyField, setEmptyField] = useState([]);

  async function getMasterData() {
    setIsLoading(true);
    try {
      const getVendor = vendor.list({});


      const getCustomer = customer.list({});

      const getCategory = workOrderCategory.list({});

      const [res, resCust, resCategory] = await Promise.all([
        getVendor,
        getCustomer,
        getCategory,
      ]);

      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data) {
          data.map((d) => {
            d["name"] = d.vendor_name;
            d["value"] = d.id;
          });
          setVendor(data);
        }
      }


      if (resCust.ok) {
        const body = await resCust.json();
        let data = body.data;
        if (data) {
          data.map((d) => {
            d["name"] = d.customer_name;
            d["value"] = d.id;
          });
          setCustomer(data);
        }
      }
      if (resCategory.ok) {
        const body = await resCategory.json();
        let data = body.data;
        if (data) {
          data.map((d) => {
            d["name"] = d.name;
            d["value"] = d.id;
          });
          setCategories(data);
        }
      }

      if (meter_id) {
    
        const res = await meter.getOne(meter_id);
  
        if(res.ok){
          const body = await res.json();
          const data = body.data;
          console.log({ data });

         
         
      if (data.asset?.location) {
        //find parent
        const locationSeq = [];
        setupLocationValues(locationSeq, data.asset.location);
        locationSeq.reverse();
        setSelectedLocation(data.asset.location);
        setSelectedLocationPrev(locationSeq);
      } else if (data.location) {
        const locationSeq = [];
        setupLocationValues(locationSeq, data.location);
        locationSeq.reverse();
        setSelectedLocation(data.location);
        setSelectedLocationPrev(locationSeq);
      }
          
          
       


          let frequency = '';
        
          if (data.reading_frequency_unit) {
            if (data.reading_frequency_unit == 'days' && data.reading_frequency_value == 1) {
              frequency = 'daily';
            }
            if (data.reading_frequency_unit == 'weeks' && data.reading_frequency_value == 1) {
              frequency = 'weekly';
            }
            if (data.reading_frequency_unit == 'months' && data.reading_frequency_value == 1) {
              frequency = 'monthly';
            }
            if (data.reading_frequency_unit == 'months' && data.reading_frequency_value == 3) {
              frequency = '3months';
            }
            if (data.reading_frequency_unit == 'months' && data.reading_frequency_value == 6) {
              frequency = '6months';
            }
            if (data.reading_frequency_unit == 'years' && data.reading_frequency_value == 1) {
              frequency = 'yearly';
            }
          }
          console.log({frequency});
          setDataToSend({
            ...dataToSend,
            title: 'Meter Reading: ' + data.meter_name + " for " + data.asset.asset_name,
            description: 'This is a meter reading for ' + data.asset.asset_name,
            asset_id: data.asset_id,
            recurring_wo: frequency,
            meter_id: data.id,
          });
          
        }
      }

      if (issue_tracking_id) {
    
        const res = await issueTracking.getOne(issue_tracking_id);
  
        if(res.ok){
          const body = await res.json();
          const data = body.data;
     
         
      if (data.asset?.location) {
        //find parent
        const locationSeq = [];
        setupLocationValues(locationSeq, data.asset.location);
        locationSeq.reverse();
        setSelectedLocation(data.asset.location);
        setSelectedLocationPrev(locationSeq);
      } else if (data.location) {
        const locationSeq = [];
        setupLocationValues(locationSeq, data.location);
        locationSeq.reverse();
        setSelectedLocation(data.location);
        setSelectedLocationPrev(locationSeq);
      }
          
          
          setDataToSend({
            ...dataToSend,
            title: 'Issue Tracking: ' + data.title ,
            description: 'Issue Tracking: ' + data.title,
            asset_id: data.asset_id,
            issue_tracking_id: data.id,
          });
          
        }
      }


      if (editMode) {
        await getRecord();
      }

      setSublocations([locations]);
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (locations.length) getMasterData();
  }, [locations]);

  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }
    //console.log({ selectedFile });
    const objectUrl = URL.createObjectURL(selectedFile);
    const newAttachment = {
      name: selectedFile.name,
      value: objectUrl,
    };
    setAttachments((prev) => [...prev, newAttachment]);
    // setPreview(objectUrl);
    //console.log({ objectUrl });
    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  async function getRecord() {
    const result = await workOrder.getOne(id);

    if (result.ok) {
      const body = await result.json();
      let data = body.data;

      const defaultValue = {
        asset_id: data.asset_id,
        number: data.number,
        start_date: format(new Date(data.start_date), "yyyy-MM-dd"),
        due_date: format(new Date(data.due_date), "yyyy-MM-dd"),
        status: data.status,
        description: data.description,
        title: data.title,
        recurring_wo: data.recurring_wo,
        recurring_end_date: data.recurring_end_date ? format(new Date(data.recurring_end_date), "yyyy-MM-dd") : "",
        is_auto_continue_recurring: data.is_auto_continue_recurring,
        priority: data.priority,
        assigned_to: data.assigned_to,
        team_id: data.team_id || "",
        vendor_id: data.vendor_id,
        category_id: data.category_id,
        inventories: data.inventories || [],
        time_entries: data.time_entries || [],
        additional_costs: data.additional_costs || [],
        is_request: isRequest,
        request_tasks: data.tasks.filter((t) => t.is_request) || [],
        work_order_tasks: data.tasks.filter((t) => !t.is_request) || [],
        meter_id: data.meter_id,
        issue_tracking_id: data.issue_tracking_id,
        problem_type_id: data.problem_type_id,
        problem_type_note: data.problem_type_note,
      };
      

      if (data.asset?.location) {
        //find parent
        const locationSeq = [];
        setupLocationValues(locationSeq, data.asset.location);
        locationSeq.reverse();
        setSelectedLocation(data.asset.location);
        setSelectedLocationPrev(locationSeq);
      } else if (data.location) {
        const locationSeq = [];
        setupLocationValues(locationSeq, data.location);
        locationSeq.reverse();
        setSelectedLocation(data.location);
        setSelectedLocationPrev(locationSeq);
      }

      if(data.problem_type) {
        const problemTypeSeq = [];
        setupProblemTypeValues(problemTypeSeq, data.problem_type);
        problemTypeSeq.reverse();
        setSelectedProblemType(data.problem_type);
        setSelectedProblemTypePrev(problemTypeSeq);
      }

      //loop data.attachments object and insert into attachments array
      const att = [];
      if (data.attachments) {
        Object.keys(data.attachments).forEach((key) => {
          if (data.attachments[key]) {
            const name = key.split("_")[3];
            const type = key.split("_")[2];
            const url = renderImage(
              `machine/attachment/${data.attachments[key]}`
            );
            const attachment = {
              origin_key: key,
              name: name,
              exist: true,
              type,
              url,
              value: data.attachments[key],
            };
            att.push(attachment);
          }
        });
        setAttachments(att);
      }

      if (data.attachments?.photo) {
        if (
          data.attachments?.photo.includes("http") ||
          data.attachments?.photo.includes("https")
        ) {
          setPreview(data.attachments?.photo);
        } else {
          setPreview(
            renderImage(`/machine/attachment/${data.attachments?.photo}`)
          );
        }
      }

      setAssignType(data.team_id ? "team" : "individual");
      setDataToSend(defaultValue);
    }
  }

  const handleAddNewCategory = async () => {
    if (!newCategory) return;
    const result = await workOrderCategory.create({
      name: newCategory,
    });

    if (result.ok) {
      const body = await result.json();
      const data = body.data;
      setCategories((prev) => [{ ...data }, ...prev]);
      setNewCategory("");
    }
  };

  const handleOnchange = (e) => {

    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };
  const handleOnchangeAsset = (e) => {
    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
    // get asset_component
    const asset_id = e.target.value;
    const comp = assets.find((a) => a.value == asset_id);
    if(comp){
      setAssetComponents(comp.component);
    } else {
      setAssetComponents([]);
    }

    // const assignedTeam = [...teams].map((team)=>{

    //   if(team.assigned_assets.some((a) => a.asset_id == asset_id)){
    //     team.name = team.team_name + " (Recommended)";
    //   }
    //   return team;
    // });
    // setTeams(assignedTeam);


    // const assignedUser = [...users].map((user)=>{
    //   if(user.assigned_assets.some((a) => a.asset_id == asset_id)){
    //     user.name = user.firstname + " " + user.lastname + " (Recommended)";
    //   }
    //   return user;
    // });
    // setUsers(assignedUser);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      let payload = { ...dataToSend };

      payload["location_id"] = selectedLocation?.id;
      
      if (payload.inventories && payload.inventories.length > 0) {
        if (payload.inventories.some((p) => p.inventory_id == "")) {
          toast.error("Some of the part is not selected!");
          return;
        }
      }
      const requestTasks = payload.request_tasks.map((t) => ({ ...t, is_request: true }));
      const workOrderTasks = payload.work_order_tasks.map((t) => ({ ...t, is_request: false }));
      payload["tasks"] = JSON.stringify([
        ...requestTasks,
        ...workOrderTasks,
      ]);
      payload["inventories"] = JSON.stringify(payload.inventories);
      payload["time_entries"] = JSON.stringify(payload.time_entries);
      payload["additional_costs"] = JSON.stringify(payload.additional_costs);
      payload["assignType"] = assignType;
      const mandatory = [
        "start_date",
        "due_date",
        "title",
        "description",
        "category_id",
        "priority",
        "location_id",
      ];
      if (assignType == "individual") mandatory.push("assigned_to");
      else mandatory.push("team_id");

      if(dataToSend.recurring_wo){
        mandatory.push("recurring_end_date");
      }


      const ef = getEmptyField(payload, mandatory);

     

      setEmptyField(ef);
      if (ef.length > 0) {
        toast.error("Mandatory field must be filled");
        return;
      }

      //console.log({ payload });
      let res;
      if (!editMode) {
        res = await workOrder.create(payload, attachments);
        await addSetupDone({ user_setup_center: "work order" });
        if (dataToSend.assigned_to && dataToSend.assigned_to !== username) {
          await addSetupDone({ user_setup_center: "assign" });
        }
      } else {
        res = await workOrder.update(id, payload, attachments);
        if (dataToSend.assigned_to && dataToSend.assigned_to !== username) {
          await addSetupDone({ user_setup_center: "assign" });
        }
      }

      if (res.ok) {
        if (isRequest) {
          toast.success(
            `Your request has been ${editMode ? "updated" : "submitted"}`
          );
        } else {
          toast.success(
            `Your work order has been ${editMode ? "updated" : "created"}`
          );
        }

        if (!editMode) {
          backToList();
        }
      } else {
        const errorBody = await res.json();
        toast.error(
          errorBody.message || "Something went wrong, please try again"
        );
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let sublocations = locations;
    const copy = [sublocations];

    const findSublocation = (lv, index) => {
      const location = sublocations.find((l) => l.id == lv);

      if (
        location &&
        location.sublocations &&
        location.sublocations.length > 0
      ) {
        copy.splice(index + 1);
        copy.push(location.sublocations);
        sublocations = location.sublocations;
      } else {
        copy.splice(index + 1);
      }
    };

    if (locationValue.length > 0) {
      locationValue.forEach((lv, index) => {
        findSublocation(lv, index);
      });
      setSublocations(copy);
    }
  }, [locationValue]);


  const getAsset = async (location_id) => {
    const res = await asset.list({ location_id });
    if (res.ok) {
      const body = await res.json();
      let data = body.data;
      if (data) {
        data.map((d) => {
          d["component"] = d.asset_components;
          d["name"] = d.asset_name;
          d["value"] = d.id;
        });
        setAssets(data);
      }
    }
  };

  const getUsers = async (location_id) => {
    const res = await user.list({ location_id });
    if (res.ok) {
      const body = await res.json();
      let data = body.data;
      if (data) {
        data.map((d) => {
          d["name"] = d.firstname + " " + d.lastname;
          d["value"] = d.username;
        });
        setUsers(data);
      }
    }
  };
  const getTeams = async (location_id) => {
    const res = await team.list({ location_id });
    if (res.ok) {
      const body = await res.json();
      let data = body.data;
      if (data) {
        data.map((d) => {
          d["name"] = d.team_name;
          d["value"] = d.id;
        });
        setTeams(data);
      }
    }
  };

  //new location implementation
  const handleChangeLocation = (location, selectedLocationPrev) => {
    setSelectedLocation(location);
    setSelectedLocationPrev(selectedLocationPrev);
    handleOnchangeAsset({
      target: {
        name: "asset_id",
        value: "",
      },
    });
    
  };

  useEffect(() => {
    if (selectedLocation) {
      getAsset(selectedLocation.id);
      getUsers(selectedLocation.id);
      getTeams(selectedLocation.id);
    } else {
      setUsers([]);
      setAssets([]);
      setTeams([]);
    }
  }, [selectedLocation]);

  useEffect(() => {
    if (dataToSend.due_date) {
      if (
        isBefore(new Date(dataToSend.due_date), new Date(dataToSend.start_date))
      ) {
        setDataToSend({
          ...dataToSend,
          due_date: "",
        });
      }
    }
  }, [dataToSend.start_date]);
  return (
    <Card>
      <LoadingIndicator open={isLoading} />
      <CardHeader>
        {editMode && "Edit "}
        {isRequest ? "Request" : "Work Order"} Information
      </CardHeader>

      <CardBody>
        <div className="row g-3">
          <div className="col-md-6">
            <NormalInput
              label={`${isRequest ? "Request" : "Work Order"} Title`}
              value={dataToSend["title"]}
              onchange={handleOnchange}
              name={"title"}
              type="text"
              id="workOrderTitle"
              emptyField={emptyField}
              className="form-control"
              required
            />


<NormalInput
                
                value={dataToSend["number"]}
                label={`${isRequest ? "Request" : "Work Order"} Number`}
                onchange={handleOnchange}
                name="number"
                type="number"
              emptyField={emptyField}
              disabled={editMode}
                helperText={`The ${isRequest ? "Request" : "Work Order"} number will be auto-generated unless a custom ${isRequest ? "Request" : "Work Order"} number is entered`}
              />

            <NormalInput
              label={"Start Date"}
              type="date"
              onchange={handleOnchange}
              value={dataToSend["start_date"]}
              name={"start_date"}
              id="startDate"
              emptyField={emptyField}
              className="form-control"
              required
            />

            <NormalInput
              label={"Due Date"}
              onchange={handleOnchange}
              value={dataToSend["due_date"]}
              min={dataToSend["start_date"]}
              name={"due_date"}
              type="date"
              id="dueDate"
              emptyField={emptyField}
              className="form-control"
              required
            />

            {!editMode && <>
           
              {!isRequest && (
                <NormalSelect
                  label={"Recurring WO"}
                  onchange={handleOnchange}
                  value={dataToSend["recurring_wo"]}
                  name={"recurring_wo"}
                  id="recurringWO"
                  className="form-select"
                  emptyField={emptyField}
                  valueKey={"id"}
                  list={recurringType}
                />
              )}


              {!isRequest && dataToSend.recurring_wo && (<NormalInput
                label={"Recurring End Date"}
                type="date"
                onchange={handleOnchange}
                value={dataToSend["recurring_end_date"]}
                name={"recurring_end_date"}
                id="recurringEndDate"
                emptyField={emptyField}
                className="form-control"
                required
              />)}
              
            </>
            }





            {!isRequest && (
              <NormalSelect
                label={"Required Signature on Completion"}
                required={false}
                onchange={handleOnchange}
                value={dataToSend["is_signature_required"]}
                name={"is_signature_required"}
                id="is_signature_required"
                className="form-select"
                emptyField={emptyField}
                valueKey={"id"}
                list={[
                    { id: true, name: "Yes" },
                    { id: false, name: "No" },
                ]}
              />
            )}

      <LocationFilter
          type="input"
          onChange={handleChangeLocation}
              defaultValue={selectedLocation}
              defaultOptionsValue={selectedLocationPrev}
              emptyField={emptyField}
            />
            
            <div className="mb-3 force-transparent" style={{ zIndex: 9999999 }}>
            <label className="form-label">Asset</label>
            <Select
              styles={{
                ...colourStyles,
                menu: (styles) => ({
                  ...styles,
                  zIndex: 9999,
                  position: "absolute",
                  color: "grey",
                }),
                menuPortal: (styles) => ({
                  ...styles,
                  zIndex: 9999,
                }),
                }}
                  menuPortalTarget={document.body}
                          menuPosition="fixed"
            options={assets.map((i) => {
              return {
                value: i.id,
                label: i.name,
              };
            })}
                value={{
                  value: dataToSend["asset_id"],
                  label: assets.find((i) => i.id == dataToSend["asset_id"])?.name,
            }}
            onChange={(e) => {
              handleOnchangeAsset({
                target: {
                  name: "asset_id",
                  value: e.value,
                },
              });
            }}
          />
            </div>
          

            {/* <NormalSelect
              label={"Asset"}
              onchange={handleOnchangeAsset}
              value={dataToSend["asset_id"]}
              name={"asset_id"}
              id="asset"
              className="form-select"
              list={assets}
              valueKey={"id"}
              emptyField={emptyField}
            /> */}
            {assetComponents.length ? (
              <NormalSelect
                label={"Also Create work order for Asset Component / Sub-Asset"}
                required={false}
                onchange={handleOnchange}
                value={dataToSend["create_wo_for_child"]}
                name={"create_wo_for_child"}
                id="create_wo_for_child"
                className="form-select"
                list={[
                  {id:"Yes", name:"Yes"},
                  {id:"No", name:"No"},
                ]}
                textKey={"name"}
                valueKey={"id"}
                emptyField={emptyField}
              />
            ) : null}
          </div>

          <div className="col-md-6">

            <ProblemTypeFilter type="input"
              defaultValue={selectedProblemType}
              defaultOptionsValue={selectedProblemTypePrev}
              onChange={(problemType) => {
              handleOnchange({
                target: {
                  name: "problem_type_id",
                  value: problemType ? problemType.id : "",
                },
              });
            }} 
            onNoteChange={(note) => {
              handleOnchange({
                target: {
                  name: "problem_type_note",
                  value: note,
                },
              });
            }}
            defaultNote={dataToSend["problem_type_note"]}
            />


            <NormalSelect
              label={"Priority"}
              onchange={handleOnchange}
              value={dataToSend["priority"]}
              name={"priority"}
              id="priority"
              className="form-select"
              valueKey={"id"}
              list={priorityType}
              emptyField={emptyField}
              required
            />

            <NormalSelect
              required={true}
              value={dataToSend["category_id"]}
              label="Category"
              onchange={handleOnchange}
              list={categories}
              name="category_id"
              emptyField={emptyField}
              valueKey={"id"}
              onSubmit={handleAddNewCategory}
              addMoreComponent={
                <NormalInput
                  required={true}
                  value={newCategory}
                  label="Category"
                  onchange={(e) => {
                    setNewCategory(e.target.value);
                  }}
                />
              }
            />
            <NormalInput
              label={"Fault / Suspected Issue"}
              onchange={handleOnchange}
              value={dataToSend["fault"]}
              type="text"
              id="fault"
              name={"fault"}
              emptyField={emptyField}
              className="form-control"
            />

            <div className="mb-3">
              <label htmlFor="assignee" className="form-label">
                Assignee
              </label>
              <select
                id="assignee"
                className="form-select"
                onChange={(e) => {
                  setAssignType(e.target.value);
                }}
                style={{
                  backgroundColor: "rgba(0, 0, 0, 0.48)",
                }}
                value={assignType}
                required
              >
                <option value="individual">Individual</option>
                <option value="team">Team</option>
              </select>
            </div>
            {assignType === "individual" && (
              <NormalSelect
                label={"Assigned to"}
                id="assignee"
                className="form-select"
                onchange={handleOnchange}
                value={dataToSend["assigned_to"]}
                name={"assigned_to"}
                required
                emptyField={emptyField}
                list={users}
                valueKey={"value"}
              />
            )}
            {assignType === "team" && (
              <NormalSelect
                label={"Assigned to"}
                id="assignee"
                className="form-select"
                onchange={handleOnchange}
                value={dataToSend["team_id"]}
                name={"team_id"}
                required
                emptyField={emptyField}
                valueKey={"value"}
                list={teams}
              />
            )}

            <NormalTextArea
              label={"Description"}
              onchange={handleOnchange}
              value={dataToSend["description"]}
              name={"description"}
              type="text"
              id="description"
              className="form-control"
              emptyField={emptyField}
              required
            />
          </div>
        </div>
        {/*<div*/}
        {/*  className="accordion"*/}
        {/*  id="accordion2"*/}
        {/*  style={{ marginBottom: "10px" }}*/}
        {/*>*/}
        {/*  <div className="accordion-item">*/}
        {/*    <h2 className="accordion-header" id="headingChat">*/}
        {/*      <button*/}
        {/*        className="accordion-button"*/}
        {/*        type="button"*/}
        {/*        data-bs-toggle="collapse"*/}
        {/*        style={{ padding: "5px" }}*/}
        {/*        data-bs-target="#collapseChat"*/}
        {/*      >*/}
        {/*        <img*/}
        {/*          src="/assets/img/ai_face.png"*/}
        {/*          style={{ width: "35px", marginRight: "10px" }}*/}
        {/*          alt=""*/}
        {/*        />*/}
        {/*        Automatically Generate Task List*/}
        {/*      </button>*/}
        {/*    </h2>*/}
        {/*    <div*/}
        {/*      id="collapseChat"*/}
        {/*      className="accordion-collapse collapse"*/}
        {/*      data-bs-parent="#accordionExample"*/}
        {/*    >*/}
        {/*      <div className="accordion-body">*/}
        {/*        <div>*/}
        {/*          Our AI assistant helps you create tasks automatically, saving*/}
        {/*          you time and effort. It intelligently generates task lists*/}
        {/*          based on your filled information, ensuring nothing is missed.{" "}*/}
        {/*        </div>*/}
        {/*        <button*/}
        {/*          className="btn btn-sm btn-outline-theme"*/}
        {/*          style={{ marginRight: "10px", marginTop: "10px" }}*/}
        {/*        >*/}
        {/*          <i className="fa fa-refresh"></i> Auto Generate Task*/}
        {/*        </button>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}

        {
          isRequest && (
            <Task
            showAddChecklist
            onChange={(v) =>
              handleOnchange({
                target: {
                  name: "request_tasks",
                  value: v,
                },
              })
            }
            value={dataToSend["request_tasks"]}
            title="Request Task List"
          />
          )
        }

<div className="mt-2">
          <Task
            showAddChecklist
            onChange={(v) =>
              handleOnchange({
                target: {
                  name: "work_order_tasks",
                  value: v,
                },
              })
            }
          value={dataToSend["work_order_tasks"]}
          title="Work Order Task List"
          />
          </div>

        {!isRequest && (
          <div className="mt-2">
            <InventorySelector
              showAddChecklist
              onChange={(v) =>
                handleOnchange({
                  target: {
                    name: "inventories",
                    value: v,
                  },
                })
              }
              value={dataToSend["inventories"]}
            />
          </div>
        )}

{!isRequest && (
          <div className="mt-2">
            <TimeTracking
              value={dataToSend["time_entries"]}
              onChange={(v) =>
                handleOnchange({
                  target: {
                    name: "time_entries",
                    value: v,
                  },
                })
              }
              workOrderId={id}
            />
          </div>
        )}

{!isRequest && (
          <div className="mt-2">
            <AdditionalCost
              value={dataToSend["additional_costs"]}
              onChange={(v) =>
                handleOnchange({
                  target: {
                    name: "additional_costs",
                    value: v,
                  },
                })
              }
            />
          </div>
        )}



        <Card style={{ marginTop: "10px" }}>
          <CardHeader>Attachments</CardHeader>
          <CardBody>
            <MultipleFilesAttachments
              attachments={attachments}
              setAttachments={setAttachments}
            ></MultipleFilesAttachments>
          </CardBody>
        </Card>

        <Card style={{ marginTop: "10px" }}>
          <LoadingIndicator open={isLoading} />
          <CardHeader>More Information</CardHeader>
          <CardBody>
            <NormalSelect
              value={dataToSend["vendor_id"]}
              label="Vendor"
              onchange={handleOnchange}
              list={vendorList}
              valueKey="id"
              name="vendor_id"
            />
          </CardBody>
        </Card>

        {!isRequest && (
          <div className="mt-4 flex">
            <button
              className="btn btn-outline-theme btn-lg me-2"
              onClick={handleSubmit}
            >
              {editMode ? "SAVE" : "ADD"}
            </button>
            <button
              className="btn btn-outline-danger btn-lg"
              onClick={backToList}
            >
              CANCEL
            </button>
          </div>
        )}
        {isRequest && (
          <div className="mt-4 flex">
            <button
              className="btn btn-outline-theme btn-lg me-2"
              onClick={handleSubmit}
            >
              {editMode ? "SAVE REQUEST" : "SUBMIT REQUEST"}
            </button>
            <button
              className="btn btn-outline-danger btn-lg"
              onClick={backToList}
            >
              CANCEL
            </button>
          </div>
        )}
      </CardBody>
    </Card>
  );
}

export default AddWorkOrder;
